export enum Permission {
    CREATE = 'CREATE',
    DELETE = "DELETE",
    READ = "READ",
    UPDATE = "UPDATE"
}